import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export function Field({ label, required, children, className = "" }) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <Label className="text-sm font-medium text-slate-700">
          {label} {required && <span className="text-brand-purple">*</span>}
        </Label>
      )}
      {children}
    </div>
  );
}

export function TextField({ label, required, testid, className, wrapClass, ...props }) {
  return (
    <Field label={label} required={required} className={wrapClass}>
      <Input
        data-testid={testid}
        className={`h-12 rounded-xl border-slate-300 bg-white text-base focus-visible:ring-brand-purple ${className || ""}`}
        {...props}
      />
    </Field>
  );
}

export function TextAreaField({ label, required, testid, wrapClass, ...props }) {
  return (
    <Field label={label} required={required} className={wrapClass}>
      <Textarea
        data-testid={testid}
        className="min-h-[110px] rounded-xl border-slate-300 bg-white text-base focus-visible:ring-brand-purple"
        {...props}
      />
    </Field>
  );
}

export function SelectField({ label, required, testid, value, onValueChange, placeholder, options, wrapClass }) {
  return (
    <Field label={label} required={required} className={wrapClass}>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger data-testid={testid} className="h-12 rounded-xl border-slate-300 bg-white text-base">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((o) => (
            <SelectItem key={o} value={o}>{o}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>
  );
}

export function CheckField({ label, testid, checked, onCheckedChange }) {
  return (
    <label className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 cursor-pointer">
      <Checkbox data-testid={testid} checked={checked} onCheckedChange={onCheckedChange} className="data-[state=checked]:bg-brand-purple data-[state=checked]:border-brand-purple" />
      <span className="text-sm font-medium text-slate-700">{label}</span>
    </label>
  );
}
